import type { PatentLinkExtend } from '../types';

export interface GetPatentLinkInput {
    docdb: string;
    pn: string;
    apn: string;
    pbd: string;
    type: string[];
    familyId: string;
}

export interface GetPatentLinkDTO {
    getPatentLink(basicData: GetPatentLinkInput): Promise<PatentLinkExtend>;
}

export const GetPatentLinkDTO = Symbol.for('GetPatentLinkDTO');
